import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import List from '../../../../components/ImportDesktopFile/Toast/List';
import { getFilesToDisplayIds } from '../selectors';

const mapStateToProps = (state: StoreState) => {
	return {
		filesIds: getFilesToDisplayIds(state),
	};
};

export default connect(mapStateToProps)(List);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ImportDesktopFile/Toast/List/index.tsx